export default {"src":"/_next/static/media/Pergolas.80b7c0c5.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};